import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';

import { LinkDirective } from '../../_shared/directives/link.directive';
import { IconName } from '../../_shared/models/icon.model';
import { EMPTY_LINK, ILink } from '../../_shared/models/link.model';
import { CheckmarkComponent } from '../../checkmark/checkmark.component';
import { IconComponent } from '../../icon/icon.component';

@Component({
    selector: 'sirius-sidebar-item',
    templateUrl: './sidebar-item.component.html',
    styleUrls: ['./sidebar-item.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: { class: 'sir-text-style-paragraph-s-bold' },
    imports: [IconComponent, LinkDirective, CheckmarkComponent],
})
export class SidebarItemComponent {
    readonly title = input('');
    readonly isParent = input(false);
    readonly icon = input<IconName | undefined>(undefined);
    readonly subtitle = input<string | undefined>(undefined);
    readonly active = input<boolean | undefined>(undefined);
    readonly link = input<ILink | undefined>(EMPTY_LINK);

    readonly leafClicked = output<Event>();

    /**
     * Fires when a non-leaf (`isParent === true`) item is activated by mouse or
     * keyboard. Emitting from a wrapping `<button>` inside the component keeps
     * keyboard activation working without a `(click)` listener on the parent
     * `<li>` (which would fail the angular-eslint a11y rules).
     */
    readonly itemClicked = output<Event>();

    /** `default` cursor when the item is purely decorative; `pointer` otherwise. */
    readonly cursor = computed<'default' | 'pointer'>(() => (!this.isParent() && !this.link() ? 'default' : 'pointer'));
}
